import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { NAV } from "@/data/content";
import { Logo } from "./Brand";
import { useCopy } from "@/lib/copy";

const linkClass = ({ isActive }) => `nav-link ${isActive ? "nav-link-active" : ""}`;

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  const t = useCopy();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open]);

  return (
    <header className="sticky top-0 z-50 border-b border-line bg-white/95 backdrop-blur-md" data-testid="site-header">
      <div className="container-x flex h-20 items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-3 rounded-sm" data-testid="header-logo-link">
          <Logo className="h-12 w-auto" />
          <span className="hidden max-w-[12rem] text-[13px] font-extrabold leading-tight text-brand sm:block">
            {t("nav.tagline")}
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden lg:block">
          <ul className="flex items-center gap-1">
            {NAV.map((n) => (
              <li key={n.to}>
                <NavLink to={n.to} className={linkClass} data-testid={`nav-${n.id}-link`}>{t(n.key)}</NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <button
          type="button"
          className="inline-flex h-11 w-11 items-center justify-center rounded-full border border-line text-brand lg:hidden"
          aria-expanded={open}
          aria-controls="mobile-nav"
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((o) => !o)}
          data-testid="mobile-menu-toggle"
        >
          {open ? <X className="h-5 w-5" aria-hidden="true" /> : <Menu className="h-5 w-5" aria-hidden="true" />}
        </button>
      </div>

      {open && (
        <nav id="mobile-nav" aria-label="Primary mobile" className="border-t border-line bg-white lg:hidden" data-testid="mobile-nav">
          <ul className="container-x flex flex-col py-4">
            {NAV.map((n) => (
              <li key={n.to} className="border-b border-line last:border-0">
                <NavLink to={n.to} className={({ isActive }) => `block py-4 text-lg font-bold ${isActive ? "text-brand" : "text-ink"}`} data-testid={`mobile-nav-${n.id}-link`}>
                  {t(n.key)}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </header>
  );
};
